module.exports = __webpack_public_path__ + "static/media/sunrise.26ce3c91.svg";